import { cities } from '@/assets/json/global'
import api from '../api/api-list'

const state = {
	simpleCity: [],
	allCity: cities,
	jdList: []
}

const actions = {
	// 获取jd职位推荐列表
	getJdJobsList: async function ({ commit }) {
		try {
			let res = await api.HrApi.getInternalList({
				from: 0,
				size: 10,
				jd_flag: 1
			})
			if (res.code === 1000) {
				commit('changeJdList', res.data.jobs)
			}
		} catch (e) {
			console.log(e)
		}
	},
}

const getters = {
	cities: state => state.simpleCity,
	cityAry: state => state.allCity.cities
}

const mutations = {
	changeSimpleCity (state, simpleCity) {
		state.simpleCity = simpleCity
	},
	changeCities (state, cities) {
		state.cities = cities
	},
	changeJdList (state, jdList) {
		state.jdList = jdList
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
